import React from 'react'

const ClipboardIcon = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 50 50' xmlSpace='preserve'>
			<path
				d='M43.8 0h-25c-3.4 0-6.2 2.8-6.2 6.2v6.1H6.2c-3.4 0-6.2 2.8-6.2 6.2v25.2C0 47.2 2.8 50 6.2 50h25c3.4 0 6.2-2.8 6.2-6.2v-6.1h6.4c3.4 0 6.2-2.8 6.2-6.2V6.2C50 2.8 47.2 0 43.8 0zM32.4 43.7c0 .7-.6 1.2-1.2 1.2h-25c-.7 0-1.2-.6-1.2-1.2V18.5c0-.7.6-1.2 1.2-1.2h25c.7 0 1.2.5 1.2 1.2v25.2zm12.7-12.2c0 .7-.6 1.2-1.2 1.2h-6.4V18.5c0-3.4-2.8-6.2-6.2-6.2H17.6v-6c0-.7.6-1.2 1.2-1.2h25c.7 0 1.2.6 1.2 1.2v25.2z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default ClipboardIcon
